import { useEffect, useState } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  findLoginStatistics,
  findReportsStatistics,
} from '@src/main/modules/common/statistics/application/find/findStatistics';
import {
  LoginStatistics,
  ReportStatistics,
  ReportStatisticsCreate,
} from '@src/main/modules/common/statistics/domain/Statistics';
import { StatisticsRepository } from '@src/main/modules/common/statistics/domain/StatisticsRepository';

export const useStatisticsUseCases = (statisticsRepository: StatisticsRepository) => {
  const [loginStatistics, setLoginStatistics] = useState<LoginStatistics[] | undefined>(undefined);
  const [reportStatistics, setReportStatistics] = useState<ReportStatistics[] | undefined>(
    undefined,
  );

  const createReportStatistics = async (reportStatisticsCreate: ReportStatisticsCreate) => {
    await statisticsRepository.saveReportStatistics(reportStatisticsCreate);
    loadReportsStatisticsInfo(statisticsRepository, setReportStatistics);
  };

  useEffect(() => {
    loadLoginStatisticsInfo(statisticsRepository, setLoginStatistics);
    loadReportsStatisticsInfo(statisticsRepository, setReportStatistics);
  }, [statisticsRepository, setLoginStatistics]);

  return { loginStatistics, reportStatistics, createReportStatistics };
};

const loadLoginStatisticsInfo = async (
  statisticsRepository: StatisticsRepository,
  setLoginStatistics: (loginStatistics: LoginStatistics[]) => void,
) => {
  const loginStatistics: LoginStatistics[] = await findLoginStatistics(statisticsRepository);
  setLoginStatistics(loginStatistics);
};

const loadReportsStatisticsInfo = async (
  statisticsRepository: StatisticsRepository,
  setReportStatistics: (reportStatistics: ReportStatistics[]) => void,
) => {
  const reportsStatistics: ReportStatistics[] = await findReportsStatistics(statisticsRepository);
  setReportStatistics(reportsStatistics);
};
